import { createStore, createHook, createActionsHook } from 'react-sweet-state';

type PageRemovalState = {
	isPageBeingRemoved: boolean;
};

const actions = {
	setIsPageBeingRemoved:
		(isPageBeingRemoved: boolean) =>
		({ setState }) => {
			setState({ isPageBeingRemoved });
		},
};

const pageRemovalStore = createStore({
	initialState: {
		isPageBeingRemoved: false,
	} as PageRemovalState,
	actions,
	name: 'pageRemovalState',
});

export const usePageRemovalState = createHook(pageRemovalStore);
export const usePageRemovalStateActions = createActionsHook(pageRemovalStore);
